module.exports = __webpack_public_path__ + "NotoSansKR-Bold-Hestia.bcacd.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Bold-Hestia.woff
// module id = ./src/_asset/sources/assets/fonts/woff/NotoSansKR-Bold-Hestia.woff
// module chunks = main